export default {
	"70046c271624aceefdf18048e78721d9": "商品價格發生變化，請聯繫客服提供新下單鏈接～",
	"405381ab0d95a7fd1506e03f331e6c09": "我知道了",
	"9b04c6f904c8c575d43aeb92719a1fbc": "聯繫客服"
}
